/* global tUrl */ // tUrl等のグローバル変数を宣言する

import './_smoothScroll.js' // スムーズスクロール
import Swiper from 'swiper' // Swiper
import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,#' + accBtn + '-close').on('click', function() {
    $(
      '#' + accBtn + ',#' + accBtn + '-open,#' + accBtn + '-close,#menu-toggle'
    ).toggleClass('active')
  })

  /*

        ######   ######  ########   #######  ##       ##
       ##    ## ##    ## ##     ## ##     ## ##       ##
       ##       ##       ##     ## ##     ## ##       ##
        ######  ##       ########  ##     ## ##       ##
             ## ##       ##   ##   ##     ## ##       ##
       ##    ## ##    ## ##    ##  ##     ## ##       ##
        ######   ######  ##     ##  #######  ######## ########

*/
  function Passive() {
    //常時実行
    if ($(window).scrollTop() > 300) {
      //トップから指定px以上スクロールしたらフェードイン
      $('#header').addClass('active')
      $('.l-header.page-header').addClass('active')
    } else {
      //スクロールが足りない時はフェードアウトする
      $('#header').removeClass('active')
      $('.l-header.page-header').removeClass('active')
    }
  }
  if ($('.l-header.top')[0]) {
    // 要素を検出したら実行
    Passive()
    var timer
    $(window).on('load scroll resize', function() {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(function() {
        Passive()
      }, 10)
    })
  }

  /*

        ######  ##      ## #### ########  ######## ########          ##     ## ##     ##
       ##    ## ##  ##  ##  ##  ##     ## ##       ##     ##         ###   ### ##     ##
       ##       ##  ##  ##  ##  ##     ## ##       ##     ##         #### #### ##     ##
        ######  ##  ##  ##  ##  ########  ######   ########  ####### ## ### ## ##     ##
             ## ##  ##  ##  ##  ##        ##       ##   ##           ##     ##  ##   ##
       ##    ## ##  ##  ##  ##  ##        ##       ##    ##          ##     ##   ## ##
        ######   ###  ###  #### ##        ######## ##     ##         ##     ##    ###

*/
  if ($('#mv-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    let mySwiper = new Swiper('#mv-slide', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      }
    })
  }

  /*

       ######## ########  ##     ## ##    ## ##    ##  #######
          ##    ##     ## ##     ## ###   ## ##   ##  ##     ##
          ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
          ##    ########  ##     ## ## ## ## #####     #######
          ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
          ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
          ##    ##     ##  #######  ##    ## ##    ##  #######

*/
  function trunk8() {
    $('.js-t8').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
  }
  trunk8()
  $(window).on('load resize', function() {
    trunk8()
  })

  $('.js-ac-menu').on('click', function() {
    // アコーディオンメニュー
    $(this)
      .toggleClass('active')
      .next()
      .toggleClass('active')
  })

  if ($('#js-mail')[0]) {
    // メールアドレス生成
    var ma = String.fromCharCode(
      125 - 23,
      97 + 0,
      120 - 21,
      95 + 21,
      141 - 30,
      95 + 19,
      111 - 6,
      79 + 31,
      107 - 4,
      62 + 2,
      136 - 26,
      99 + 12,
      51 - 2,
      103 + 12,
      124 - 23,
      85 + 29,
      124 - 6,
      105 + 0,
      106 - 7,
      96 + 5,
      61 - 15,
      83 + 16,
      117 - 6,
      23 + 23,
      126 - 20,
      95 + 17
    )
    var mt = String.fromCharCode(
      124 - 15,
      62 + 35,
      129 - 24,
      59 + 49,
      160 - 44,
      63 + 48,
      105 - 47
    )
    var mail =
      '<a class="right" href="' +
      mt +
      ma +
      '">' +
      '<img src="' +
      tUrl +
      'img/recruit_contact_text_03.png" alt="メールアドレス">' +
      '</a>'
    var addMail = document.getElementById('js-mail')
    addMail.insertAdjacentHTML('afterbegin', mail)
  }

  /*

  ######   ######  ########   #######  ##       ##       ########     ###    ########
 ##    ## ##    ## ##     ## ##     ## ##       ##       ##     ##   ## ##   ##     ##
 ##       ##       ##     ## ##     ## ##       ##       ##     ##  ##   ##  ##     ##
  ######  ##       ########  ##     ## ##       ##       ########  ##     ## ########
       ## ##       ##   ##   ##     ## ##       ##       ##     ## ######### ##   ##
 ##    ## ##    ## ##    ##  ##     ## ##       ##       ##     ## ##     ## ##    ##
  ######   ######  ##     ##  #######  ######## ######## ########  ##     ## ##     ##

*/
  if ($('.scroll-box')[0]) {
    // 要素を検出したら実行
    // eslint-disable-next-line no-unused-vars
    const psL = new PerfectScrollbar('.scroll-box.left')
    // eslint-disable-next-line no-unused-vars
    const psR = new PerfectScrollbar('.scroll-box.right')
  }
})
